import { render } from "./DocumentReportAutovalidation.vue?vue&type=template&id=158bf033&scoped=true&ts=true"
import script from "./DocumentReportAutovalidation.vue?vue&type=script&lang=ts"
export * from "./DocumentReportAutovalidation.vue?vue&type=script&lang=ts"

import "./DocumentReportAutovalidation.vue?vue&type=style&index=0&id=158bf033&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-158bf033"]])

export default __exports__